import { render, staticRenderFns } from "./MainAccount.vue?vue&type=template&id=212b1eb3&scoped=true"
import script from "./MainAccount.vue?vue&type=script&lang=js"
export * from "./MainAccount.vue?vue&type=script&lang=js"
import style0 from "./MainAccount.vue?vue&type=style&index=0&id=212b1eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b1eb3",
  null
  
)

export default component.exports